import './ClGalleryEmpty.css';

import React from 'react';

import classname from '@search/classname/src';
import Icon from '@vtblife/uikit-icons';

const cn = classname.bind(null, 'ClGalleryEmpty');

export function ClGalleryEmpty({
    children = <Icon size='xl' name='camera-crossed' />
}: {
    children?: React.ReactNode;
}) {
    return (
        <div className={cn()}>{children}</div>
    );
}
